export const Version = '2016-03-04';
export const Service = 'kec';
export const KecPath = '/kecapi/';
// export const KecPath = '/console-kec-api/';
export const source = 'kec';

export const getAvoidList = {
    path: KecPath,
    params: {
        Action: 'DescribeDataGuardGroup',
        Service,
        Version,
        source
    },
    method: 'get'
};

export const getTagKeysList = {
    path: KecPath,
    params: {
        Action: 'DescribeTagKeys',
        Version,
        Service: 'tag',
        resourceType: 'kec-instance',
        maxResults: 1000,
        source
    },
    method: 'get'
};
export const describeTagValues = {
    path: KecPath,
    params: {
        Action: 'DescribeTagValues',
        Version,
        Service: 'tag',
        maxResults: 1000,
        nextToken: '',
        source
    },
    method: 'get'
};
export const getProjects = {
    path: KecPath,
    params: {
        Action: 'GetAccountProjectList',
        Version: '2015-11-01',
        source,
        Service: 'iam'
    },
    method: 'get'
};
export const getAvoidPackage = {
    path: KecPath,
    params: {
        Action: 'QueryPriceSystem',
        Service,
        Version,
        source
    },
    method: 'get'
};
export const createAviod = {
    path: KecPath,
    params: {
        Action: 'CreateDataGuardGroup',
        Service,
        Version,
        source
    },
    method: 'get'
};
export const calcAvoidPrice = {
    path: KecPath,
    params: {
        Action: 'CalculateDataGuardPrice',
        Version,
        Service,
        source
    },
    method: 'post'
};
export const describeKeys = {
    path: KecPath,
    params: {
        Action: 'DescribeKeys',
        Service: 'sks',
        Version: '2015-11-01',
        source
    },
    method: 'post'
};

//获取kec服务下所有IAM角色列表
export const describeKecIamRoles = {
    path: KecPath,
    params: {
        Action: 'DescribeKecIamRoles',
        Service: 'iam',
        Version: '2021-04-21',
        source
    },
    method: 'post'
};

export const getTimeddelDate = {
    path: KecPath,
    params: {
        Action: 'GetAutoDeleteTime',
        Version,
        Service,
        source
    },
    method: 'post'
};

export const CheckKeyEncryption = {
    path: KecPath,
    params: {
        Action: 'CheckKeyEncryption',
        Version,
        Service,
        source
    },
    method: 'get'
};